import React from "react";
import { Controller } from "react-hook-form";
import { Input, Select, SelectItem, Checkbox, CheckboxGroup } from "@heroui/react";
import { useTranslation } from "react-i18next";
import { useUseCases } from "@/context/UseCasesProvider";

export default function UserFormAccount({ methods, classNames, dataUser, dataEntities }) {
  const { t } = useTranslation();
  const settingsInterface = useUseCases();
  
  return (
    <>
      <Controller
        name="user_name"
        control={methods.control}
        defaultValue={dataUser.user_name}
        render={({ field }) => (
          <Input
            {...field}
            type="text"
            label={t("name")}
            placeholder={t("name")}
            variant="flat"
            labelPlacement="outside"
            classNames={classNames}
            isRequired
          />
        )}
      />

      <Controller
        name="user_given_name"
        control={methods.control}
        defaultValue={dataUser.user_given_name}
        render={({ field }) => (
          <Input
            {...field}
            type="text"
            label={t("first_name")}
            placeholder={t("first_name")}
            variant="flat"
            labelPlacement="outside"
            classNames={classNames}
            isRequired
          />
        )}
      />

      <Controller
        name="availability"
        control={methods.control}
        defaultValue={dataUser.availability}
        render={({ field }) => (
          <Select
            {...field}
            label={t("status")}
            classNames={classNames}
            defaultSelectedKeys={[dataUser.availability]}
            labelPlacement="outside"
            disableSelectorIconRotation
            disallowEmptySelection
            onChange={(value) => field.onChange(value)}
          >
            <SelectItem key="active">{t("active")}</SelectItem>
            <SelectItem key="inactive">{t("inactive")}</SelectItem>
          </Select>
        )}
      />
      
      {settingsInterface?.settings?.display?.features?.entity && (
      <Controller
        name="allow_update_entities"
        control={methods.control}
        defaultValue={dataUser.allow_update_entities ? "true" : "false"}
        render={({ field }) => (
          <Select
            {...field}
            label={t("allow_update_entities")}
            classNames={classNames}
            defaultSelectedKeys={[field.value]}
            labelPlacement="outside"
            disableSelectorIconRotation
            disallowEmptySelection
            onChange={(value) => field.onChange(value)}
            data-cy="allow_update_entities"
          >
            <SelectItem key="true">{t("authorized")}</SelectItem>
            <SelectItem key="false">{t("unauthorized")}</SelectItem>
          </Select>
        )}
      />
      )}

      <Controller
        name="allow_update_assignees"
        control={methods.control}
        defaultValue={dataUser.allow_update_assignees ? "true" : "false"}
        render={({ field }) => (
          <Select
            {...field}
            label={t("allow_update_assignees")}
            classNames={classNames}
            defaultSelectedKeys={[field.value]}
            labelPlacement="outside"
            disableSelectorIconRotation
            disallowEmptySelection
            onChange={(value) => field.onChange(value)}
          >
            <SelectItem key="true">{t("authorized")}</SelectItem>
            <SelectItem key="false">{t("unauthorized")}</SelectItem>
          </Select>
        )}
      />

      <Controller
        name="user_email"
        control={methods.control}
        defaultValue={dataUser.user_email}
        render={({ field }) => (
          <Input
            {...field}
            type="text"
            label={t("email")}
            placeholder={t("email")}
            variant="flat"
            labelPlacement="outside"
            classNames={classNames}
            isReadOnly
          />
        )}
      />

      <Controller
        name="entities"
        control={methods.control}
        render={({ field }) => (
          <CheckboxGroup
            {...field}
            label={t("entity_visibility")}
            classNames={classNames}
            isRequired
            color="default"
            size="sm"
            onChange={(value: string[] | React.FormEvent<HTMLDivElement>) => {
              if (Array.isArray(value)) {
                field.onChange(value);
              }
            }}
          >
            {dataEntities.map((entity) => (
              <Checkbox key={entity.entity_id} value={entity.entity_id}>
                {entity.entity_name}
              </Checkbox>
            ))}
          </CheckboxGroup>
        )}
      />
    </>
  );
}
